import type { IconSvgObject } from './types';

const MinusPlusCircle01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 7.5H8.5M9 13.5H12M12 13.5H15M12 13.5V16.5M12 13.5V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MinusPlusCircle01Icon;
